/* global module */
'use strict';
/**
 * Services                                                                                                 Directives - Web Components
 * ************************************************************************************************************************************
 */
const angular = require('angular');
require('angular-translate');
require('angular-translate-loader-static-files');

// A variant of https://github.com/juristr/angular-translate-loader-pluggable
angular
  .module('angular-translate-loader-pluggable', [
    'pascalprecht.translate'
  ])
  .provider('translatePluggableLoader', function () {
    let loaders = [];
    let translationTable = {};

    this.useLoader = function (loaderName, options) {
      loaders.push({
        name: loaderName,
        options: options
      });

      return this;
    };

    this.translations = function (language, translations) {
      translationTable[language] = angular.extend({}, translationTable[language], translations);

      return this;
    };

    this.$get = function ($q, $injector) {
      return function (options) {
        let deferred = $q.defer();

        let loaderInstances = [];

        // lookup in loaders
        for (let i = 0; i < loaders.length; i++) {
          let loader = loaders[i];

          // get the loader and resolve it, passing in the required options
          let loaderPromise = $injector.get(loader.name)(angular.extend(options, loader.options));
          loaderInstances.push(loaderPromise);
        }

        // lookup in translation table, override everything else.
        loaderInstances.push(function () {
          let deferred2 = $q.defer();

          deferred2.resolve(translationTable[options.key]);

          return deferred2.promise;
        } ());

        $q.all(loaderInstances)
          .then(function (loadersList) {
            let result;

            for (let i = 0; i < loadersList.length; i++) {
              result = angular.extend({}, result, loadersList[i]);
            }

            deferred.resolve(result);
          });


        return deferred.promise;
      };
    };
    this.$get.$inject = ['$q', '$injector'];
  });

/**
 * Internationalization (i18n) and Localization (l10n) module for the continu-app
 *
 * @param {$translateProvider} $translateProvider the i18n transaltion provider to configure the keys and values to translate
 */
var app = angular.module('learn-i18n-l10n', ['learn-app-setup', 'pascalprecht.translate', 'angular-translate-loader-pluggable'])
.config(['appConfigurationProvider', '$translateProvider', 'translatePluggableLoaderProvider', function(appConfigurationProvider, $translateProvider, translatePluggableLoaderProvider) {

  $translateProvider.useLoader('translatePluggableLoader');

  translatePluggableLoaderProvider.useLoader('$translateStaticFilesLoader', {
    prefix: './translations/',
    suffix: '.json'
  });

  var customCopy = appConfigurationProvider.$get().customCopy;
  if (customCopy) {
    for (const langKey of Object.keys(customCopy)) {
      var customCopyObj = {};
      for (const transPair of customCopy[langKey]) {
        customCopyObj[transPair.key] = transPair.value;
      }
      translatePluggableLoaderProvider.translations(langKey, customCopyObj);
    }
  }

  $translateProvider.registerAvailableLanguageKeys(
    [
      'en',
      'ar',
      'zh_CN',
      'zh_TW',
      'fr',
      'fr_CA',
      'de',
      'hi_IN',
      'id',
      'it',
      'ja',
      'ko',
      'pl',
      'pt_BR',
      'ru',
      'es_LA',
      'es_ES',
      'es_419',
      'sv_SE',
      'vi',
      'th'
    ], {
    'en_*' : 'en',
    'eng' : 'en',
    'es_LA': 'es_LA',
    'spa': 'es_LA',
    'deu': 'de'
  })
  .preferredLanguage('en') 
  .fallbackLanguage('en') 
  .determinePreferredLanguage()
  .useSanitizeValueStrategy('sce');

  $translateProvider.use();

}]);

module.exports = app;
